import { render, staticRenderFns } from "./mallUserDetail.vue?vue&type=template&id=0a855964&scoped=true"
import script from "./mallUserDetail.vue?vue&type=script&lang=js"
export * from "./mallUserDetail.vue?vue&type=script&lang=js"
import style0 from "./mallUserDetail.vue?vue&type=style&index=0&id=0a855964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a855964",
  null
  
)

export default component.exports